import { Grid } from 'opensolar-ui'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

type ProductTileLayoutProps = {
  Thumb: React.ReactNode
  DescriptionRow: React.ReactNode
  PricingRow: React.ReactNode
  BulkRow: React.ReactNode | false
  DistributorRow: React.ReactNode
  ConnectRow: React.ReactNode
  Action: React.ReactNode
  onClick?: () => void
  liteMode?: boolean
}

const useStyles = makeOpenSolarStyles((theme) => ({
  container: ({ liteMode }: { liteMode?: boolean }) => ({
    minWidth: '252px',
    maxWidth: '252px',
    padding: theme.spacing(2, 2, 3, 2),
    overflow: 'hidden',

    background: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid',
    borderColor: 'transparent',
    ...(!liteMode
      ? {
          '&:hover': {
            borderColor: theme.straitPalette.blue[800],
            cursor: 'pointer',
          },
        }
      : {}),
  }),
  section: {
    flex: 2,
  },
  distributorConnectSection: {
    flex: '0 0 auto',
  },
  expoRibbonContainer: {
    minHeight: '27px',
  },
  infoContainer: {
    flexDirection: 'column',
    gap: 16,
    marginBottom: theme.spacing(2),
  },
}))

export const ProductTileLayout = ({
  Thumb,
  DescriptionRow,
  PricingRow,
  DistributorRow,
  BulkRow,
  ConnectRow,
  Action,
  onClick,
  liteMode = false,
}: ProductTileLayoutProps) => {
  const classes = useStyles({ liteMode })

  return (
    <Grid
      item
      container
      className={classes.container}
      direction="column"
      justify="space-between"
      alignItems="center"
      data-testid="product-tile"
      onClick={liteMode ? undefined : onClick}
    >
      <Grid item container>
        <Grid item container className={classes.section} direction="column">
          {Thumb}
        </Grid>
      </Grid>
      <Grid item container className={classes.infoContainer}>
        <Grid container item justify="flex-end" direction="column" spacing={1} className={classes.section}>
          <Grid item>{DescriptionRow}</Grid>
        </Grid>

        {!liteMode && (
          <Grid
            item
            container
            justify="center"
            direction="column"
            spacing={1}
            className={classes.distributorConnectSection}
          >
            <Grid item>{DistributorRow}</Grid>
            <Grid item>{ConnectRow}</Grid>
          </Grid>
        )}
        <Grid item container direction="column" spacing={1} className={classes.section}>
          <Grid item>{PricingRow}</Grid>
        </Grid>
        {BulkRow && <>{BulkRow}</>}
      </Grid>
      <Grid item container onClick={(e) => e.stopPropagation()}>
        <Grid item container justify="center" alignItems="center" spacing={1}>
          <Grid item style={{ width: '100%' }}>
            {Action}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
